const title = process.env.VUE_APP_BASE_TITLE || "Admin Website Smarthand";

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}
